module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "vehicle-gallery"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    staticClass: "layout_fullwidth_padding"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('img', {
    staticClass: "back_image_button",
    attrs: {
      "src": "/static/images/icons/black/back.png",
      "alt": "",
      "title": ""
    }
  })]), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "photo-container"
  }, [_c('ul', {
    class: {
      'photo_gallery_13': _vm.imageViewId == 0,
      'photo_gallery_12': _vm.imageViewId == 1,
      'photo_gallery_11': _vm.imageViewId == 2
    },
    attrs: {
      "id": "photoslist"
    }
  }, _vm._l((_vm.vehicle.photos), function(image, key) {
    return _c('li', {
      key: key,
      attrs: {
        "image": image
      }
    }, [_c('a', {
      staticClass: "swipebox",
      attrs: {
        "rel": "gallery-3",
        "href": image
      }
    }, [_c('img', {
      attrs: {
        "src": image,
        "alt": "image"
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottombarpages",
    style: ({
      'background-color': _vm.customization.mainColor,
      'color': _vm.customization.fontColor
    })
  }, [_c('div', {
    staticClass: "gallery_switch"
  }, [_c('a', {
    staticClass: "switcher active",
    attrs: {
      "href": "#",
      "id": "view13"
    },
    on: {
      "click": function($event) {
        return _vm.changeImageView(0)
      }
    }
  }, [_c('span', {
    staticClass: "icon-customer-app icon-switch13",
    style: ([_vm.imageViewId == 0 ? {
      'color': _vm.customization.iconColor
    } : {
      'color': _vm.customization.fontColor
    }])
  })]), _vm._v(" "), _c('a', {
    staticClass: "switcher",
    attrs: {
      "href": "#",
      "id": "view12"
    },
    on: {
      "click": function($event) {
        return _vm.changeImageView(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-customer-app icon-switch12",
    style: ([_vm.imageViewId == 1 ? {
      'color': _vm.customization.iconColor
    } : {
      'color': _vm.customization.fontColor
    }])
  })]), _vm._v(" "), _c('a', {
    staticClass: "switcher",
    attrs: {
      "href": "#",
      "id": "view11"
    },
    on: {
      "click": function($event) {
        return _vm.changeImageView(2)
      }
    }
  }, [_c('span', {
    staticClass: "icon-customer-app icon-switch11",
    style: ([_vm.imageViewId == 2 ? {
      'color': _vm.customization.iconColor
    } : {
      'color': _vm.customization.fontColor
    }])
  })])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0296c6df", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0296c6df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/inventory/vehicle-gallery.vue
// module id = 778
// module chunks = 0